import { useEffect, useState } from "react";
import Cartcard from "./cartCard";
import { useNavigate } from "react-router-dom";

import Switch from '@mui/material/Switch';

import fabric_src from '../assets/samples/SAMPLE.png'

import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

function Cart({setChange, modal_item ,setModalItem, cartItems, setCart, deleteFromCart, inCart, setInCart }) {
    const navigate = useNavigate()

    const [toggle, setToggle] = useState(false)

    

    useEffect(()=>{
        // console.log(cartItems)
        if(cartItems){
            generateCart()
        }
        
    }, [toggle, cartItems])

    const generateCart = ()=>{
        try{
            let carts = []
            let FabricsCart = []


            for(let i =  0;i<cartItems.length;i++){

                if(toggle && ( !Object.keys(cartItems[i]).includes("item_type"))){
                    const typs  = cartItems[i].types
                    typs.forEach(element => {
                        carts.push({
                            "item_type":2,
                            "type" : element,
                            "fabric": cartItems[i].fabric[element],
                            "price" : cartItems[i].fabric[element].price,
                            "discount" : cartItems[i].fabric[element].discount ? cartItems[i].fabric[element].discount : 0,
                            "style": cartItems[i].style[element],
                            "measurements":cartItems[i].measurements
                        })    
                    });
                    
                } else{
                    // if(Object.keys(cartItems[i]).includes("item_type") && cartItems[i].item_type === 0){
                    //     FabricsCart.push(cartItems[i])
                    // } else {
                        carts.push(cartItems[i])
                    // }
                    
                } 
            }
            // if(FabricsCart && FabricsCart.length>0){
            //     carts.push({
            //         item_type:0,
            //         src:fabric_src,
            //         name : "Fabric Sample Set",
            //         items : FabricsCart,
            //         id : (new Date().getTime()).toString(),
            //         price : FabricsCart.length>=2 ? 250 : 100
            //.f-loading img     })
            // }
            // console.log("From cart :", carts)
            setInCart(carts)

        } catch(e){
            console.log(e)
        }
    }

    
    return (
    <div className="Cart">

        { cartItems && cartItems.length>0 && (
            <div className="cart-header">
                Your Shopping Cart
            </div>
        )}
        
        {inCart && inCart.length >0 && inCart.map((value, key)=>{
            return(
                
                <Cartcard item={value} key={key} deleteFromCart={deleteFromCart}
                            toggle = {toggle} setToggle = {setToggle}
                            setModalItem = {setModalItem}
                />
            )
        })
            
        }
        {(!cartItems || (cartItems && cartItems.length == 0)) && (
            <div className="empty-cart-container">
                <div className="empty-cart-title">Your Shopping Cart is Empty</div>
                <div className="empty-cart-desc">Build your custom suits within few minutes and get it delivered within 14 days !!</div>

                <a href="/" style={{textDecoration:"none"}}>
                <button className="btn-primary"
                    onClick={()=>{
                        
                    }}
                >Shop Now</button>
                </a>
            </div>
        )

        }

    </div>);
}

export default Cart;